import { useMemo } from "react";

import useQueriedRecords from "../../../api/api-hooks/records/useQueriedRecords";

const useMapData = ({
  moduleAPIName,
  record,
  query,
  validator,
  topLevelFilters,
  viewFilters,
  locationField,
  queryKeyID,
}: {
  moduleAPIName: string;
  record: string;
  query: any;
  validator: any;
  topLevelFilters: any;
  viewFilters: any;
  locationField: string;
  queryKeyID?: string;
}) => {
  const variableValues = useMemo(() => {
    let vals: any = {};
    if (record) {
      vals["record"] = record;
    }

    return vals;
  }, [record]);

  const { records, recordsLoading, pagination } = useQueriedRecords({
    moduleAPIName: moduleAPIName,
    query: {
      ...query,
      ...(query?.Fields &&
        locationField && { Fields: [...query?.Fields, locationField] }),
    },
    topLevelFilters: topLevelFilters,
    viewFilters: viewFilters,
    queryValidator: (query: any) => validator(query),
    variableValues: variableValues,
    useDefaultVariables: true,
    queryKeyID: queryKeyID,
  });

  const countFieldName = !!query?.Lookup?.[0]?.ModuleAPIName
    ? `${query?.Lookup?.[0]?.ModuleAPIName}_count`
    : null;

  const data = useMemo(() => {
    return records.map((r: any) => {
      const locationValues = r?.[locationField];
      let mainLocation = locationValues?.find((l: any) => !!l.Primary);

      if (!mainLocation) {
        mainLocation = locationValues?.[0];
      }

      return {
        ...r,
        _coordinates: mainLocation?.Geo
          ? {
              lng: mainLocation?.Geo?.coordinates?.[0] ?? 0,
              lat: mainLocation?.Geo?.coordinates?.[1] ?? 0,
            }
          : null,
      };
    });
  }, [locationField, records, query]);

  return {
    mapData: data as Record<string, any>[],
    mapDataLoading: recordsLoading,
    countFieldName: countFieldName,
    pagination: pagination,
    mapError:
      !validator(query) || (!recordsLoading && (!records || !records.length)),
  };
};

export default useMapData;
